import React, {  } from 'react';
import { Divider, Spin } from 'antd';

import { CollectionServer, JSXMap, ObjectToContextFilters, QueryParam, updateInArray } from 'fennec-ui'
import { DropdownAction } from 'fennec-ui'
import { POST, errorCatch } from 'fennec-ui'
import "./index.css"

import NovieYacheikiUslugi from '../../forms/NovieYacheikiUslugi'
import IzmenitYacheikiUslugi from '../../forms/IzmenitYacheikiUslugi';
import ContextDescription from '../../../fedance-ui/ContextDescription';
import AddYacheikaVPromokodi from '../../forms/AddYacheikaVPromokodi';

export default function YacheikiUslugiBlock(props) {
    const { auth, source, queryDetail, create, ctx, sourceKey, title, size, event } = props;

    const filters = () => [
        {
            name: "prilozhenie.ID",
            sort: true,
            filter: true,
            label: "Регистрация",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    data: [
                        { ID: 1, name: "Да" },
                        { ID: 2, name: "Нет" },
                    ]
                },
                type: "many-one",
            },
            queryComparer: (value, item) => {
                if (value == 1) {
                    return "nnu"
                } else if (value == 2) {
                    return "nu"
                }
                return ""
            }
        },
        {
            name: "notActive",
            sort: true,
            filter: true,
            label: "Активная",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    data: [
                        { ID: 1, name: "Да" },
                        { ID: 2, name: "Нет" },
                    ]
                },
                type: "many-one",
            },
            queryRaw: (value, item, key) => {
                if (value == 1) {
                    return QueryParam("w-eq-" + key, "false")
                } else if (value == 2) {
                    return QueryParam("w-eq-" + key, "true")
                }
                return ""
            }
        },
    ]

    const createAction = (values, unlock, close, { collection, setCollection }) => {
        POST(auth, "/api/yacheikiuslugi/new", {
            ...values,
            ...((ctx) ? ctx : {}),
            ...((event?.ID) ? { meropriyatieID: event.ID } : {}),
            artist: { userID: values?.artist?.ID },
        }, ({ data }) => {
            if (data) {
                setCollection(o => updateInArray(o, data))
            }
            close();
        }, (err) => errorCatch(err, unlock));
    };

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-10`} style={{ minWidth: "25px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-8`} style={{ left: "25px", minWidth: "280px", maxWidth: "280px", backgroundColor: "white" }} rowSpan={2}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
                                        Название
                                    </div>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "405px", maxWidth: "405px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "405px" }}>
                                        Описание
                                    </div>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "100px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "100px" }}>
                                        {/* <i className="fa fa-telegram"></i> */}
                                        Участник
                                    </div>
                                </th>
                                <th className={`height-10`} style={{ minWidth: "100px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "100px" }}>
                                        {/* <i className="fa fa-vk"></i> */}
                                        Зритель
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, idx) => {
                                return (<tr key={idx}>
                                    <td className={`fixed pointer height-5`} style={{ minWidth: "25px", backgroundColor: "white" }} onClick={(e) => { e.stopPropagation() }}>
                                        <DropdownAction
                                            placement="bottomLeft"
                                            style={{ padding: "0" }}
                                            button={() => (
                                                <div className={`bg ${(item?.notActive)?"bg-red":"bg-grey"} pointer`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                                                    <i className="fa fa-bars" style={{ fontSize: "11px" }}></i>
                                                </div>
                                            )}
                                            items={modelActions(item, idx)?.map((e, idx) => ({
                                                key: e.key || idx,
                                                auth: auth,
                                                mode: "MenuItem",
                                                object: item,
                                                collection: collection,
                                                setCollection: setCollection,
                                                ...e
                                            }))} />
                                    </td>
                                    <td className={`fixed height-5`} style={{ left: "25px", minWidth: "280px", maxWidth: "280px", backgroundColor: "white" }}>
                                        <div className={`bg ${(item?.notActive)?"bg-red dark-1":"bg-grey light-30"} border-transparent`} style={{ textAlign: "left", height: "100%" }}>
                                            <div style={{fontWeight:"bold"}}>{item?.nazvanie}</div>
                                            {/* <div style={{ color: "#6a6a6a" }}><ContextDescription object={item} /></div> */}
                                            <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                            }}>
                                               <ContextDescription object={item} />
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "405px", maxWidth: "405px", backgroundColor: "white" }}>
                                        <div className={`bg ${(item?.notActive)?"bg-red":"bg-grey"} dark-1 border-transparent`} style={{ textAlign: "left", height: "100%", minWidth: "405px", maxWidth: "405px" }}>
                                            {item?.opisanie}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
                                        <div className={`bg ${(item?.notActive)?"bg-red":"bg-grey"} dark-1 border-transparent`} style={{ textAlign: "center", height: "100%", minWidth: "100px", maxWidth: "100px" }}>
                                            {(!item?.prilozhenieID) && <div>
                                                <span style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>Нет</span>
                                            </div>}
                                            {(item?.prilozhenieID) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    Да
                                                </span>
                                            </div>}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
                                        <div className={`bg ${(item?.notActive)?"bg-red":"bg-grey"} dark-1 border-transparent`} style={{ textAlign: "center", height: "100%", minWidth: "100px", maxWidth: "100px" }}>
                                            {(!item?.zritel) && <div>
                                                <span style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>Нет</span>
                                            </div>}
                                            {(item?.zritel) && <div>
                                                <span style={{ fontWeight: "bold", textWrap: "nowrap" }}>
                                                    Да
                                                </span>
                                            </div>}
                                        </div>
                                    </td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin >
        </div >)
    }

    return (
        <div style={{ padding: "5px 10px" }}>
            {title || <Divider type="horizontal" orientation="left">
                Позиции
            </Divider>}
            <CollectionServer
                auth={auth}

                floatingFilter={true}
                disableScrollTo={true}
                allowFullscreen={true}

                name={"YacheikiUslugi"}
                queryDetail={queryDetail}
                source={source}
                filters={filters}
                size={"small"}
                mode={"list"}
                title={title || "Позиции"}

                contextFilters={ObjectToContextFilters(ctx)}
                customRender={render}

                collectionActions={() => {
                    let organizatorKey = {}
                    if (event?.organizatorFederatsiyaID) {
                        organizatorKey = { organizatorFederatsiyaID: event?.organizatorFederatsiyaID }
                    } else if (event?.organizatorRegionalnoeOtdelenieID) {
                        organizatorKey = { organizatorRegionalnoeOtdelenieID: event?.organizatorRegionalnoeOtdelenieID }
                    } else if (event?.organizatorShkolaID) {
                        organizatorKey = { organizatorShkolaID: event?.organizatorShkolaID }
                    } else if (event?.organizatorMeropriyatiyaID) {
                        organizatorKey = { organizatorMeropriyatiyaID: event?.organizatorMeropriyatiyaID }
                    }
                    if (!create) {
                        return []
                    }
                    return [
                        {
                            action: createAction,
                            triggerOptions: {
                                type: "primary"
                            },
                            form: NovieYacheikiUslugi,
                            title: "Новая позиция",
                            modal: {
                                title: "Новая позиция",
                                width: "55%",
                                minWidth: "400px",
                            }
                        },
                    ]
                }}
                modelActions={(item, index) => {
                    let organizatorKey = {}
                    if (event?.organizatorFederatsiyaID) {
                        organizatorKey = { organizatorFederatsiyaID: event?.organizatorFederatsiyaID }
                    } else if (event?.organizatorRegionalnoeOtdelenieID) {
                        organizatorKey = { organizatorRegionalnoeOtdelenieID: event?.organizatorRegionalnoeOtdelenieID }
                    } else if (event?.organizatorShkolaID) {
                        organizatorKey = { organizatorShkolaID: event?.organizatorShkolaID }
                    } else if (event?.organizatorMeropriyatiyaID) {
                        organizatorKey = { organizatorMeropriyatiyaID: event?.organizatorMeropriyatiyaID }
                    }

                    return [
                        {
                            // ...props,
                            title: "Изменить",
                            auth: auth,
                            modal: {
                                width: "55%",
                                minWidth: "400px",
                                title: "Изменить позицию",
                            },
                            object: item,
                            mode: "MenuItem",
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POST(auth, '/api/yacheikiuslugi/update', {
                                    ...values, ID: (item) ? item.ID : undefined,
                                    artist: { userID: values?.artist?.ID },
                                },
                                    ({ data }) => {
                                        setCollection(o => updateInArray(o, data))
                                        close();
                                    },
                                    (err) => errorCatch(err, unlock)
                                );
                            },
                            create: create,
                            sourceKey: sourceKey,
                            soruceID: item?.meropriyatieID,
                            form: IzmenitYacheikiUslugi,
                            queryFilterContext: (ctx) ? ctx : organizatorKey,
                        },
                        {
                            title: "Добавить в промокоды",
                            auth: auth,
                            modal: {
                                width: "700px",
                                title: "Добавить услугу в промокоды",
                            },
                            object: item,
                            mode: "MenuItem",
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POST(auth, '/api/yacheikiuslugi/append-in-promokodi', {
                                    ...values, 
                                    promokodiList: values.promokodiList?.map(item => item.ID),
                                    yacheikiUslugiID: (item) ? item.ID : undefined,
                                }, ({ data }) => {
                                        // setCollection(o => updateInArray(o, data))
                                        close();
                                    },
                                    (err) => errorCatch(err, unlock)
                                );
                            },
                            create: create,
                            sourceKey: sourceKey,
                            soruceID: item?.meropriyatieID,
                            form: AddYacheikaVPromokodi,
                            queryFilterContext: (ctx) ? ctx : organizatorKey,
                        }
                    ]
                }}
            />
        </div>
    );
}
